import moment from "moment";

export const isEmpty = (text: string) => {
  if (text.length === 0) {
    return true;
  } else {
    return false;
  }
};

export const validEmail = (email: string) => {
  const regex =
    /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*/;
  return regex.test(email);
};

export const validPhone = (phone: string) => {
  const regex =
    /^\d{10}$/;
  return regex.test(phone);
};

export const getCurrentTimeFromTimeStamp = (timeStamp: number) => {
  let formattedDate = moment(timeStamp).format("dddd, MMMM Do YYYY");
  return formattedDate;
};

export const convertTimeStampToTime = (time: number) => {
  const date = new Date(time);
  return date.toISOString().slice(0, 10);
};

export const isValidateSAIDNumber = (idNumber: string) => {
  if (idNumber.length !== 13) {
    return false;
  }
  // Apply Luhn formula for check-digits
  let tempTotal = 0;
  let checkSum = 0;
  let multiplier = 1;

  for (let i = 0; i < 13; ++i) {
    tempTotal = parseInt(idNumber.charAt(i), 10) * multiplier;
    if (tempTotal > 9) {
      tempTotal = Math.floor(tempTotal / 10) + (tempTotal % 10);
    }
    checkSum += tempTotal;
    multiplier = multiplier % 2 === 0 ? 1 : 2;
  }

  if (checkSum % 10 !== 0) {
    return false;
  }
  return true;
};
